import { render, staticRenderFns } from "./carouselAdd.vue?vue&type=template&id=425c6978&scoped=true&"
import script from "./carouselAdd.vue?vue&type=script&lang=js&"
export * from "./carouselAdd.vue?vue&type=script&lang=js&"
import style0 from "./carouselAdd.vue?vue&type=style&index=0&id=425c6978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425c6978",
  null
  
)

export default component.exports